import { render } from "./vsupplier.vue?vue&type=template&id=785ceb08&scoped=true"
import script from "./vsupplier.vue?vue&type=script&lang=js"
export * from "./vsupplier.vue?vue&type=script&lang=js"

import "./vsupplier.vue?vue&type=style&index=0&id=785ceb08&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785ceb08"]])

export default __exports__